import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import { invertColor } from "../common/util";

export default function SubjectChip(props) {
	let { subject } = props;
	if (!subject?.name) {
		return;
	}

	const size = props?.size
	const href = '/subjects/' + subject.id;
	const style = { ...props.style, backgroundColor: subject.colour, color: invertColor(subject.colour, true) };

	if (window.location.pathname != href && !props?.hideLink) {
		return <Chip label={subject.name} size={size} style={style} component={Link} href={href} clickable />
	}
	else {
		return <Chip label={subject.name} size={size} style={style} />
	}
}